import { AuthContext } from '@/js/shared/context/AuthContext';
import { IEvent, IEventBookingTime } from '@/types/event';
import { Button, Grid, Icon } from '@material-ui/core';

import { makeStyles, Theme } from '@material-ui/core/styles';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { EntityBooking } from './EntityBooking';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    // padding: theme.spacing(1),
    // borderRadius: 5,
    // backgroundColor: theme.palette.background.shadedown_10,
  },
  headline: {
    paddingBottom: theme.spacing(1),
  },
}));

export const EntityBookingList = ({
  hasAdminAccess,
  entityId,
  event,
  bookingUpdates,
  gridSize = 4,
}: {
  hasAdminAccess: boolean;
  entityId: string;
  event: IEvent;
  bookingUpdates: number;
  gridSize?: number;
}) => {
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const [bookingEvent, setBookingEvent] = useState<IEvent>(null);
  const iHaveBooked =
    bookingEvent?.event_booking_times.find((e) =>
      e.visitors.find((v) => v.id === authState.user.id)
    ) !== undefined;
  const reloadBookings = () => {
    axios
      .get(`/api/visitor/entities/${entityId}/bookings/${event.id}`)
      .then((res) => {
        setBookingEvent(res.data);
      });
  };
  useEffect(() => {
    reloadBookings();
  }, [entityId, bookingUpdates]);

  return (
    <div className={classes.root}>
      <div className={classes.headline}>{event.booking_settings.headline}</div>

      {bookingEvent && bookingEvent.event_booking_times.length > 0 && (
        <Grid container spacing={1}>
          {bookingEvent.event_booking_times.map(
            (bookingTime: IEventBookingTime) => (
              <EntityBooking
                entityId={entityId}
                event={event}
                bookingTime={bookingTime}
                key={bookingTime.id}
                reloadBookings={reloadBookings}
                iHaveBooked={iHaveBooked}
                hasAdminAccess={hasAdminAccess}
                gridSize={gridSize}
              />
            )
          )}
        </Grid>
      )}
    </div>
  );
};
EntityBookingList.displayName = 'EntityBookingList';
